module.exports = __webpack_public_path__ + "assets/img/hj3.41808a89.png";